export default {
  list: [],
  defectValue: undefined,
  eventsList: []
}
